import { SourceRepositoryMultipleIcon } from './SourceRepositoryMultipleIcon';

/**
 * author: Austin Andrews
 * id 16D37AE7-409E-48A5-BE24-9DCBA0792FD7
 * name source-repository-multiple
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/source-repository-multiple.svg
 * tags
 * - Developer / Languages 
 */
export const SourceRepositoriesIcon = SourceRepositoryMultipleIcon;
export default SourceRepositoriesIcon